import { useQuery } from '@tanstack/react-query';
import ArticlesService from '../services/articles.service';

export function useAdminArticle(articleId: string | undefined) {
  return useQuery({
    queryKey: ['admin-article', articleId],
    queryFn: () => ArticlesService.getArticleById(articleId!),
    enabled: !!articleId,
  });
}
